export const MemberModel = {
  membership_category: '',
  name: '',
  s_d_w_o: '',
  cnic_no: '',
  shot_gun_license_no: '',
  rifle_22_license_no: '',
  pistol_9mm_license_no: '',
  shot_gun_no: '',
  rifle_22_no: '',
  pistol_9mm_no: '',
  occupation: '',
  organization: '',
  qualification: '',
  present_address: '',
  permanent_address: '',
  telephone_no: '',
  mobile_phone: '',
  off_no: '',
  affiliated: '',
  email: '',
  date:'',
  member_status: 'active',
  closing_date: '',
  closing_remarks: '',
  members: [],
  family_members: [],
  photographs: [],
  arm_license_attachments: [],
  service_card_attachments: [],
  new_photographs: [],
  new_arm_license_attachments: [],
  new_service_card_attachments: [],
}


export const MEMBER_FAMILY_DETAILS = {
  family_member_name: '',
  relationship: ''
}

export const AFFILIATED_TYPE_YES = 1;
export const AFFILIATED_TYPE_NO = 2;

export const AFFILIATED_TYPE_NAME = {
  1: 'Yes',
  2: 'No',
};
export const AFFILIATED_TYPE_DROPDOWN_OPTIONS = [
  { value: AFFILIATED_TYPE_YES, label: AFFILIATED_TYPE_NAME[AFFILIATED_TYPE_YES] },
  { value: AFFILIATED_TYPE_NO, label: AFFILIATED_TYPE_NAME[AFFILIATED_TYPE_NO] },
];

export const MEMBER_CATEGORY_CIVILIAN = 1
export const MEMBER_CATEGORY_ARMED_FORCES = 2
export const MEMBER_CATEGORY_POF_EMPLOYEE = 3
export const MEMBER_CATEGORY_WIL_EMPLOYEE = 4
export const MEMBER_CATEGORY_WALKING_CUSTOMERS = 5

export const MEMBER_CATEGORY_NAMES = {
  [MEMBER_CATEGORY_CIVILIAN]: 'Civilian',
  [MEMBER_CATEGORY_ARMED_FORCES]: 'Armed Forces',
  [MEMBER_CATEGORY_POF_EMPLOYEE]: 'POF Employees',
  [MEMBER_CATEGORY_WIL_EMPLOYEE]: 'WIL Employees',
  [MEMBER_CATEGORY_WALKING_CUSTOMERS]: 'Walking Customers',
}

export const MEMBER_CATEGORY_DROPDOWN_OPTIONS = [
  { value: MEMBER_CATEGORY_CIVILIAN, label: MEMBER_CATEGORY_NAMES[MEMBER_CATEGORY_CIVILIAN] },
  {
    value: MEMBER_CATEGORY_ARMED_FORCES,
    label: MEMBER_CATEGORY_NAMES[MEMBER_CATEGORY_ARMED_FORCES],
  },
  {
    value: MEMBER_CATEGORY_POF_EMPLOYEE,
    label: MEMBER_CATEGORY_NAMES[MEMBER_CATEGORY_POF_EMPLOYEE],
  },
  {
    value: MEMBER_CATEGORY_WIL_EMPLOYEE,
    label: MEMBER_CATEGORY_NAMES[MEMBER_CATEGORY_WIL_EMPLOYEE],
  },
  {
    value: MEMBER_CATEGORY_WALKING_CUSTOMERS,
    label: MEMBER_CATEGORY_NAMES[MEMBER_CATEGORY_WALKING_CUSTOMERS],
  },
]
